module.exports = __webpack_public_path__ + "img/android_padlock.b1a594aa.png";